export const FAIL_FETCH = 'FAIL_FETCH'
export const FETCH_GLOBAL_CONFIG = 'FETCH_GLOBAL_CONFIG'
export const LOAD_GLOBAL_CONFIG = 'LOAD_GLOBAL_CONFIG'

/**
 * failFetch
 * @desc Fail Fetch Action Generator
 * @param {Object} error
 * @return {action} failFetchAction
 */
export function failFetch (error) {
  return { type: FAIL_FETCH, error }
}

/**
 * fetchGlobalConfig
 */
export function fetchGlobalConfig () {
  return { type: FETCH_GLOBAL_CONFIG }
}

/**
 * loadGlobalConfig
 * @desc Load global config
 * @param {Object} data data to load
 * @return {action} loadGlobalConfigAction
 */
export function loadGlobalConfig (data) {
  return { type: LOAD_GLOBAL_CONFIG, data }
}
